import styled, { css } from 'styled-components';
import { COLORS } from '../../ui';
import { Icon } from './../Icon';

interface Props {
  width?: string;
  fixed?: boolean;
  show?: boolean;
  resize?: boolean;
}

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  height: 50px;
  z-index: 1;
  background-color: ${COLORS.YELLOW};
  padding: 13px 15px;
  box-sizing: border-box;

  @media(min-width: 480px) {
    display: none;
  }
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: black;
  max-width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Toggle = styled(Icon)`
  position: absolute;
  left: 15px;
  cursor: pointer;

  svg {
    color: ${COLORS.BLACK};
  }
`;

export const Overlay = styled.div`
  display: none;

  ${(props: Props) => props.show && css`
    display: block;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    cursor: pointer;
    z-index: 2;
  `}

  @media (min-width: 480px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  width: 80px;
  min-width: 80px;
  height: 100%;
  transform: translateX(-80px);
  transition: .2s linear;
  position: fixed;
  z-index: 3;

  ${(props: Props) => props.width && css`
    width: ${props.width};
    min-width: ${props.width};
  `}

  ${(props: Props) => props.show && css`
    transform: none;
    z-index: 3;
  `}

  @media (min-width: 480px) {
    transform: none;
    position: relative;
    z-index: 3;
  }
`;

export const SidebarStyled = styled.nav`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: ${(props: Props) => props.width ? props.width : '80px'};
  background: ${COLORS.YELLOW};
  padding: 20px 12px;
  box-sizing: border-box;

  ${(props: Props) => props.fixed && css`
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100%;
  `}
`;

export const Isotipo = styled.div`
  margin-bottom: ${(props: Props) => props.resize ? '0' : '40px'};
`;

export const Menu = styled.ul`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

Header.displayName = 'Header';
Title.displayName = 'Title';
Toggle.displayName = 'Toggle';
Overlay.displayName = 'Overlay';
Wrapper.displayName = 'Wrapper';
SidebarStyled.displayName = 'SidebarStyled';
Isotipo.displayName = 'Isotipo';
Menu.displayName = 'Menu';